import axios from 'axios'
import { ApiErrorResponse, parseApiError } from './apiError'

/** Código con el que `parseApiError` marca una respuesta de error que no respeta el contrato del backend. */
const UNKNOWN_ERROR = 'UNKNOWN_ERROR'

/**
 * Convierte un error de un pedido con `responseType: 'blob'` en `ApiErrorResponse` (contrato `ErrorResponse`).
 *
 * Con `responseType: 'blob'` el cuerpo del error también llega como `Blob`: se lo lee como texto y se parsea el JSON
 * para que `parseApiError` vea el `errorCode` y el mensaje del backend. Si no es un JSON del contrato (timeout, sin
 * conexión, proxy) devuelve el error genérico propio del front.
 *
 * Los servicios de internación, urgencias y recién nacidos tienen su propia copia de esta lectura
 * (`unwrapBlobError` / `withReadableError`); los reportes nuevos usan esta.
 */
export async function readBlobError(error: unknown): Promise<ApiErrorResponse> {
    if (axios.isAxiosError(error) && error.response && error.response.data instanceof Blob) {
        try {
            error.response.data = JSON.parse(await error.response.data.text()) as unknown
        } catch {
            error.response.data = null
        }
    }
    return parseApiError(error)
}

/**
 * Mensaje para mostrar cuando falla un export: el del backend solo si es un error de negocio (4xx con el contrato:
 * formato inválido, sin permiso, rango inválido), que ya viene filtrado y dice qué hacer; si no (red, servidor,
 * respuesta sin contrato), el texto genérico de la acción.
 */
export async function exportErrorMessage(error: unknown, genericText: string): Promise<string> {
    const apiError = await readBlobError(error)
    const isBusinessError = apiError.status >= 400 && apiError.status < 500 && apiError.errorCode !== UNKNOWN_ERROR
    return isBusinessError ? apiError.message : genericText
}
